import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformLeadsCard } from "./-components/platform-leads-card";

export const Route = createFileRoute("/_authenticated/platform_/leads")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-leads"),
  component: PlatformLeads,
});

/** People AI's own leads. */
function PlatformLeads() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="People AI leads"
        meta="Who reached People AI, how, and how far Shelby got."
      />
      <PlatformLeadsCard />
    </div>
  );
}
